<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
  title: t('pages.toDownload.meta.title'),
  description: t('pages.index.meta.description'),
})
</script>

<template>
  <main>
    <UiBanner :title="$t('pages.toDownload.label')" />
    <Download class="mb-10" />
  </main>
</template>
